(function () {
  'use strict';

  var MINIMUM = 12;
  var scanPending = false;

  function quantityInput(form) {
    return form.querySelector('input[name="quantity"]');
  }

  function validateForm(form, report) {
    var input = quantityInput(form);
    if (!input) return true;

    var quantity = Number.parseInt(input.value, 10) || 0;
    var valid = quantity >= MINIMUM;
    var message = valid ? '' : 'Please choose at least 12 pieces before adding this item to your cart.';

    input.setCustomValidity(message);
    form.dataset.pgMinimumInvalid = String(!valid);

    if (!valid && report) {
      input.focus({ preventScroll: true });
      input.reportValidity();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  }

  function prepareForm(form) {
    var input = quantityInput(form);
    if (!input) return;

    if (input.type === 'number') {
      var nativeMinimum = Number.parseInt(input.min, 10) || 1;
      input.min = String(Math.max(nativeMinimum, MINIMUM));
      input.dataset.min = input.min;
    }
    validateForm(form, false);
  }

  function scanForms() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(prepareForm);
  }

  function scheduleScan() {
    if (scanPending) return;
    scanPending = true;
    window.requestAnimationFrame(function () {
      scanPending = false;
      scanForms();
    });
  }

  document.addEventListener('input', function (event) {
    if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'quantity') return;
    var form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (form) validateForm(form, false);
  });

  document.addEventListener('quantity-selector:update', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var form = target && target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    window.requestAnimationFrame(function () {
      validateForm(form, false);
    });
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('form[data-type="add-to-cart-form"]')) return;
      if (validateForm(event.target, true)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  function start() {
    scanForms();
    if (document.body) {
      new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
